import { Component, OnInit } from '@angular/core';
import { Validators, ValidatorFn, ValidationErrors } from '@angular/forms';

import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import {ApiService} from "../api.service";

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.sass']
})
export class ResetPasswordComponent implements OnInit {
    passwordMathValidator: ValidatorFn = (control: FormGroup): null => {
        const password = control.get('password');
        const passwordRepeat = control.get('passwordRepeat');
        if (password && passwordRepeat && password.value !== passwordRepeat.value) {
            control.get('passwordRepeat').setErrors({ 'passwordMismatch': true });
        }
        return null;
    };

    form = new FormGroup({
        resetCode: new FormControl('', [Validators.required]),
        password: new FormControl('', [Validators.required]),
        passwordRepeat: new FormControl('', [Validators.required])
    }, {validators: this.passwordMathValidator});

    constructor(private apiService: ApiService, private router : Router) { }

    ngOnInit() {}
    onSubmit() {
        if(!this.form.valid) {
            return;
        };
        console.log("Send Request");
        this.handleResponse(true);
        this.apiService.resetPassword(this.form.value.resetCode, this.form.value.password).subscribe(this.handleResponse);
    }

    handleResponse = (resp) => {
        if(resp) {
            this.router.navigate([{outlets: {modal: 'login'}}]);
        }
    }

}
